// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"4781e684","453":"7b0bb287"}[chunkId] + ".chunk.js";
};